// extracted by mini-css-extract-plugin
export default {"modalOverlay":"mE-z","modalContent":"nE-z","header":"oE-z","close":"pE-z"};